import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SEOService } from '../../services/seo.service';
import { StructuredDataService } from '../../services/structured-data.service';
import { WebContentSchema } from '../../types/structured-data.interfaces';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  private document = inject(DOCUMENT);
  private seoService = inject(SEOService);
  private structuredDataService = inject(StructuredDataService);

  ngOnInit() {
    this.setSeoMetadata();
    this.setStructuredData();
  }

  private setSeoMetadata() {
    const canonicalUrl = `${environment.canonicalOrigin}/privacy-policy`;

    this.seoService.updateTags({
      title: 'Privacy Policy | Summerry',
      description:
        "Summerry's Privacy Policy explains how we collect, use, and protect your personal data when you use our AI news aggregation platform.",
      keywords: 'Privacy Policy, Summerry, data protection, GDPR, cookies, user privacy',
      type: 'website',
      url: canonicalUrl,
      image: `${environment.canonicalOrigin}/assets/og/black-og-image-1x.png`,
    });
  }

  private setStructuredData() {
    const origin = environment.canonicalOrigin;
    this.structuredDataService.addWebPage({
      name: 'Privacy Policy',
      description:
        "Summerry's Privacy Policy explains how we collect, use, and protect your personal data when you use our AI news aggregation platform.",
      breadcrumbItems: [{ name: 'Home', item: origin }, { name: 'Privacy Policy' }],
      mainEntity: {
        '@type': 'WebContent',
        name: 'Privacy Policy',
        url: `${origin}/privacy-policy`,
        datePublished: environment.legalDocs.initialPublish,
        dateModified: environment.legalDocs.lastUpdated,
        text: `This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You. We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.`, // Abridged for brevity
        author: {
          '@id': `${origin}/#organization`,
        },
        publisher: {
          '@id': `${origin}/#organization`,
        },
      } as WebContentSchema,
    });
  }
}
